import React from 'react';
import styled from 'styled-components';
import MonthItem from './MonthItem';

const MonthsList = ({ data: months, onMonth, selectedMonth }) => {
  return (
    <Container>
      {months.length > 0 && <Title>Seleccione un mes *</Title>}
      {months.map((month) => (
        <MonthItem
          key={month.id}
          month={month}
          onMonth={onMonth}
          selectedMonth={selectedMonth}
        />
      ))}
    </Container>
  );
};

const Container = styled.section`
  margin-top: 1em;
  display: flex;
  flex-wrap: wrap;
  width: 68%;
  justify-content: center;
`;

const Title = styled.div`
  width: 100%;
  text-align: center;
`;

export default MonthsList;
